import PropTypes from "prop-types";
import * as React from "react";
import { Link } from "react-ui";

import { EXPERT_ERRORS_NAVIGATE_TO_UNIT_CLICK } from "../../metricsAction";
import { track } from "../../Internals/Metrics/MetricsProvider";
import { pullContext } from "../../TypingUtils";

interface Props {
    children: JSX.Element;
    unitId: string;
}

interface NavigateLinkContext {
    handleClose: () => void;
}

export class NavigateLink extends React.PureComponent<Props> {
    public static contextTypes = {
        handleClose: PropTypes.func,
    };
    public scrollTo = () => {
        track("candy", EXPERT_ERRORS_NAVIGATE_TO_UNIT_CLICK, { unitId: this.props.unitId });
        this.getContext().handleClose();

        // Иначе скрол происходит до закрытия модального окна
        // И возвращается на первоначальную страницу с аттачментами
        setTimeout(() => {
            const unit = document.querySelector(this.props.unitId);
            if (unit) {
                unit.scrollIntoView();
            }
        }, 0);
    };

    public render(): JSX.Element {
        return <Link onClick={this.scrollTo}>{this.props.children}</Link>;
    }

    private getContext(): NavigateLinkContext {
        return pullContext<NavigateLinkContext>(this);
    }
}
